import React, {useCallback, useEffect, useRef, useState} from 'react';
import {
  createNavigationContainerRef,
  NavigationContainer,
} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import routes from '../router';
import FloatDevSetting from '../views/AViewComponents/DevSetting';
import GlobalComponents from './GlobalComponents';
import {RouteParamsList} from '../router/ParamsList';
import FloatAIBao from './FloatAIBao';
import {PageTrackProvider, usePageTrack} from '../context/PageTrackContext';
import {GradeUpgradeProvider} from '../context/GradeUpgradeContext';
import {getToken} from '../request/token';
// import {NotificationProvider} from '../context/InAppNotification';
// import {useCheckToken} from '../request/token';
const Stack = createStackNavigator();

export const navigationRef = createNavigationContainerRef<RouteParamsList>();

export function routeNavigate(name: keyof RouteParamsList, params?: any) {
  // @ts-ignore
  navigationRef.current?.navigate(name, params);
}

// 创建一个内部组件来使用 usePageTrack
function RouterContent() {
  const [currentRouteName, setCurrentRouteName] = useState<string | undefined>(
    undefined,
  );
  const isReadyRef = useRef(false);
  const lastRouteNameRef = useRef<string | undefined>(undefined);
  const {setCurrentPage} = usePageTrack();

  const handleStateChange = useCallback(() => {
    const currentRoute = navigationRef.current?.getCurrentRoute();
    const routeName = currentRoute?.name;

    if (routeName !== lastRouteNameRef.current) {
      lastRouteNameRef.current = routeName;
      setCurrentRouteName(routeName);
      setCurrentPage(routeName);
    }
  }, [setCurrentPage]);
  const onReady = useCallback(() => {
    getToken().then(res => {
      console.log('getToken', res);
      if (!res) {
        // @ts-ignore
        navigationRef.current?.navigate('Login');
      }
    });
    isReadyRef.current = true;
    handleStateChange();
  }, [handleStateChange]);

  return (
    <NavigationContainer
      ref={navigationRef}
      onReady={onReady}
      onStateChange={handleStateChange}>
      <FloatAIBao currentRouteName={currentRouteName}>
        <Stack.Navigator screenOptions={{headerStyle: {}}}>
          {routes.map(route => (
            <Stack.Screen key={route.name} {...route} />
          ))}
        </Stack.Navigator>
      </FloatAIBao>
      <FloatDevSetting />
      <GlobalComponents />
    </NavigationContainer>
  );
}

// 主组件
export default function Router() {
  return (
    <PageTrackProvider>
      <GradeUpgradeProvider>
        {/*<NotificationProvider>*/}
        <RouterContent />
        {/*</NotificationProvider>*/}
      </GradeUpgradeProvider>
    </PageTrackProvider>
  );
}
